var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import * as React from 'react';
import Base from './Base';
const Tiny = (props, ref) => {
    const { block = true, className } = props, restProps = __rest(props, ["block", "className"]);
    const component = block ? `div` : `span`;
    return (React.createElement(Base, Object.assign({ ref: ref }, restProps, { className: classNames('typography-tiny-v2', className), component: component })));
};
export default React.forwardRef(Tiny);
